import React, { } from 'react';
import { Button, Col } from 'reactstrap'
import { Dialog } from 'primereact/dialog';
import { AlertTriangle } from "react-feather";

export const AlertDataTable = (props) => {
    console.log("🚀 ~ AlertDataTable ~ props:", props)

    const { titleAlert, visibleAlert, headerColor = "#0d3b59", onHideAlert, sizeAlert = "medium-dialog",
        loadingAlert = false, titleLoading, titleNotLoading, titleDanger, buttonAcept = false, actionAcept,
        messageAlert, alert1 = true, titleAlert1 } = props;

    return (
        <>
            <Dialog
                header={titleAlert ?? "---"}
                visible={visibleAlert}
                headerStyle={{
                    backgroundColor: headerColor,
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: headerColor, color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                onHide={onHideAlert}
                className={sizeAlert}
                footer={
                    <>
                        {
                            buttonAcept && <Button
                                size="sm"
                                color="danger"
                                type="button"
                                onClick={actionAcept}
                            >
                                {loadingAlert ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                        {titleLoading ?? "Procesando..."}
                                    </>
                                ) : (
                                    titleNotLoading ?? "---"
                                )}
                            </Button>
                        }
                        <Button
                            size="sm"
                            type="button"
                            color="secondary"
                            className="btn-air-light"
                            onClick={onHideAlert}
                        >
                            {titleDanger ?? "---"}
                        </Button>
                    </>
                }
            >
                <Col sm="12" className='pt-1 pl-0 pr-0' >
                    <Col sm="12" className='pl-0 pr-0 pt-2' >
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                            marginBottom: "15px"
                        }}>
                            <div style={{
                                backgroundColor: "#ffe6e6",
                                borderRadius: "50%",
                                width: "60px",
                                height: "55px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <AlertTriangle
                                    size={28}
                                    color="#c92a2a"
                                    style={{ display: "block" }}
                                />
                            </div>
                            <div>
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: "13px",
                                        color: "#0d3b59"
                                    }}
                                >
                                    {messageAlert ?? "---"}
                                </p>
                            </div>
                        </div>
                        {
                            alert1 ?
                                <div style={{
                                    background: "#f8fbff",
                                    padding: "12px 14px",
                                    borderRadius: "8px",
                                    border: "1px solid #d7e7f5"
                                }}>
                                    <span style={{ fontWeight: 500, color: "#0d3b59" }}>
                                        {titleAlert1 ?? "---"}
                                    </span>
                                </div>
                                :
                                <div
                                    style={{
                                        color: "#856404",
                                        fontSize: "0.78rem",
                                        marginTop: "6px",
                                        fontWeight: "500",
                                        backgroundColor: "#fff3cd",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        border: "1px solid #ffeeba",
                                    }}
                                >
                                    <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                    {titleAlert1 ?? "---"}
                                </div>
                        }
                    </Col>
                </Col>
            </Dialog >
        </>
    )
}